import { render, staticRenderFns } from "./MtIframe.vue?vue&type=template&id=0ba00655&scoped=true&"
import script from "./MtIframe.vue?vue&type=script&lang=js&"
export * from "./MtIframe.vue?vue&type=script&lang=js&"
import style0 from "./MtIframe.vue?vue&type=style&index=0&id=0ba00655&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba00655",
  null
  
)

export default component.exports